import React from 'react';
import PropTypes from 'prop-types';

import { token } from '@zillow/constellation';

import { StyledBar } from './StyledComponents';

const propTypes = {
  isActive: PropTypes.bool.isRequired,
  left: PropTypes.number.isRequired,
  right: PropTypes.number.isRequired,
};

const ProgressBar = ({ isActive, left, right }) => (
  <div>
    <StyledBar
      borderColor={isActive ? token('colors.blue500') : token('colors.coolGray400')}
      left={left}
      right={right}
    />
  </div>
);

ProgressBar.propTypes = propTypes;

export { ProgressBar };
export default ProgressBar;
